import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
  jwtInterceptor,
  recaptchaInterceptor,
  refreshTokenInterceptor,
  errorInterceptor,
} from '@app/core/interceptors';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarConfig } from '@angular/material/snack-bar';
import { NUMBER_PRECISION, NumberPrecisionOptions } from './core/tokens/number-format.token';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import Big from 'big.js';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntl } from '@app/core/services/custom-mat-paginator-intl.service';

// set global rounding mode for the whole app
Big.RM = Big.roundDown;

const defaultFormat: NumberPrecisionOptions = {
  integer: 15,
  decimal: 8,
  separator: ',',
};

const GLOBAL_FORM_FIELD_OPTIONS: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  subscriptSizing: 'fixed',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptorsFromDi(),
      // reCAPTCHA runs first so the token is already on the request by the time
      // the auth and error interceptors see it.
      withInterceptors([
        recaptchaInterceptor,
        jwtInterceptor,
        refreshTokenInterceptor,
        errorInterceptor,
      ]),
    ),
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 3000,
        panelClass: ['app-snackbar'],
      } as MatSnackBarConfig,
    },
    { provide: NUMBER_PRECISION, useValue: defaultFormat },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: GLOBAL_FORM_FIELD_OPTIONS,
    },
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
};
